import api from './api';

const BASE_URL = '/ponds';

class PondService {
  constructor() {
    this.httpClient = api;
  }

  async pondList() {
    try {
      const response = await (await this.httpClient.get(`${BASE_URL}`)).data;
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }
}

export default new PondService();
